import React, {useState, useEffect, useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';
import navStyle from './style';
import {Link} from 'react-router-dom';

export default function DesctopNav({navDetails, signOutPressed}) {
	let [toggle, setToggle] = useState(true);
	let user = useContext(GlobalContext).user;

	let style = navStyle();
	return (
		<nav style={style.outerContainer()}>
			<ul style={style.side('left')}>
				<li
					style={{
						...style.li(),
						...{
							marginRight: '1rem',
						},
					}}
				>
					<Link className='navLink' to={navDetails.logo.href} style={style.link()}>
						<p className='me-2' style={style.titleText()}>
							{navDetails.logo.name}
						</p>
						<i className='fas fa-weight-hanging' style={style.logoIcon()}></i>
					</Link>
				</li>
				{navDetails.left.map((entrie, i) => {
					return (
						<li key={i} className={i !== 0 ? 'ms-2' : ''}>
							<Link key={i} className='navLink' to={entrie.href} style={style.link()}>
								<p style={style.navText()} key={i}>
									{entrie.name}
								</p>
							</Link>
						</li>
					);
				})}
			</ul>
			<ul style={style.side('right')}>
				{navDetails.right.map((entrie, i) => {
					return (
						<li
							key={i}
							style={{
								...style.li(),
								...{
									marginLeft: i !== 0 ? '1rem' : '0',
								},
							}}
						>
							<Link key={i} className='navLink' to={entrie.href} style={style.link()}>
								<p key={i} style={style.navText()}>
									{entrie.name}
								</p>
							</Link>
						</li>
					);
				})}
				{!user || !user.name ? (
					navDetails.auth.map((entrie, i) => {
						return (
							<li
								style={{
									...style.li(),
									...{
										marginLeft: '1rem',
									},
								}}
								key={i}
							>
								<Link key={i} className='navLink' to={entrie.href} style={style.link()}>
									<p style={style.navText()}>{entrie.name}</p>
								</Link>
							</li>
						);
					})
				) : (
					<>
						<li
							style={{
								...style.li(),
								...{
									marginLeft: '1rem',
								},
							}}
						>
							<Link className='navLink' to={'#'} style={style.link()}>
								<p style={style.navText()}>Hello {user.name.first}</p>
							</Link>
						</li>
						<li
							style={{
								...style.li(),
								...{
									marginLeft: '1rem',
								},
							}}
						>
							<Link className='navLink' style={style.link()} onClick={signOutPressed}>
								<p style={style.navText()}>Sign out</p>
							</Link>
						</li>
					</>
				)}
			</ul>
		</nav>
	);
}
